import { render, staticRenderFns } from "./TipSelection.vue?vue&type=template&id=52b9d2b8&scoped=true"
import script from "./TipSelection.vue?vue&type=script&lang=js"
export * from "./TipSelection.vue?vue&type=script&lang=js"
import style0 from "./TipSelection.vue?vue&type=style&index=0&id=52b9d2b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9d2b8",
  null
  
)

export default component.exports